import { HealthcareProviderLocation } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { addressFormatter, commonTranslationKeys, createTranslatedText, FormContextValues } from '@dreryk/react-common';
import { SecondaryText, Select, StyledFlex, Text } from '@dreryk/react-components';

import { statisticsTranslationKeys } from '../../../translations';

import {
   healthcareProviderLocationKeyExtractor,
   healthcareProviderLocationSelectFilterCreator,
   healthcareProviderLocationTriggerLabelExtractor,
} from './HealthcareProviderLocationSelect.utils';

const HEALTHCARE_PROVIDER_LOCATION_FIELD_NAME = 'healthcareProviderLocation';
export type HealthcareProviderLocationSelectFieldValue = {
   [HEALTHCARE_PROVIDER_LOCATION_FIELD_NAME]: HealthcareProviderLocation | null;
};

type HealthcareProviderLocationSelectProps = Pick<
   FormContextValues<HealthcareProviderLocationSelectFieldValue>,
   'register'
> & {
   readonly healthcareProviderLocations: HealthcareProviderLocation[];
};

export const HealthcareProviderLocationSelect = (props: HealthcareProviderLocationSelectProps): JSX.Element => {
   return (
      <Select<HealthcareProviderLocation>
         testId={HEALTHCARE_PROVIDER_LOCATION_FIELD_NAME}
         triggerLabelExtractor={healthcareProviderLocationTriggerLabelExtractor}
         controller={props.register(HEALTHCARE_PROVIDER_LOCATION_FIELD_NAME, { required: true })}
         placeholder={commonTranslationKeys.choose}
         label={statisticsTranslationKeys.formFields.healthcareProviderLocation.label}
         searchInputEnabled
      >
         <Select.Filter
            items={props.healthcareProviderLocations}
            filter={healthcareProviderLocationSelectFilterCreator}
         >
            {({ filteredItems }) => (
               <Select.List<HealthcareProviderLocation>
                  items={filteredItems}
                  keyExtractor={healthcareProviderLocationKeyExtractor}
               >
                  {(location) => (
                     <Select.Item<HealthcareProviderLocation>
                        item={location}
                        label={
                           <StyledFlex direction={'column'}>
                              <Text testId={'name'}>
                                 <Select.Highlight node={createTranslatedText(location.name)} />
                              </Text>
                              <SecondaryText
                                 testId={'address'}
                                 text={
                                    <Select.Highlight node={createTranslatedText(addressFormatter(location.address))} />
                                 }
                                 compact
                              />
                           </StyledFlex>
                        }
                        testId={location.locationIdentifier.locationId}
                     />
                  )}
               </Select.List>
            )}
         </Select.Filter>
      </Select>
   );
};
